import { TypographyStylesProvider, Code } from "@mantine/core";
import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import DocsButton from "../articlesHelpers/DocsButton"; // Import the new component
import { IconPlugConnected, IconUsers } from "@tabler/icons-react";

export const ADD_PEERS_CONTENT = (
  <TypographyStylesProvider>
    <p>Peers are other nodes on the network which you can connect to.</p>

    <p>On the Lightning Network, your peers serve two related functions:</p>
    <ol>
      <li>
        <strong>Gossip data</strong>: Peers share information about the network
        with you. This includes the network addresses of other nodes, and the
        size and topography of channels on the network.
      </li>
      <li>
        <strong>Channels</strong>: You can open channels with your peers, and
        they can open channels with you, so payments can be routed between you.
      </li>
    </ol>
    <p>
      Rizful Node$1 When you start Rizful, you will automatically be "peered"
      with the Rizful LSP. You can also add more peers with this button:
    </p>

    <DocsButton
      ariaLabel="add peer"
      text="Add Peer"
      leftSection={<IconPlugConnected />}
      disabled={false}
    />

    <p>To add a peer, you need to know that peer's URI. </p>

    <p>
      A URI (Uniform Resource Identifier) is kind of like a URL. It looks
      complicated, but once you break it apart, it's not so bad.
    </p>

    <p>
      {" "}
      Here is the URI of the well-known{" "}
      <a href="https://megalithic.me" target="_blank">
        Megalith Node:
      </a>
    </p>
    <Code
      style={{
        wordWrap: "break-word", // Ensures the word wraps to the next line
        wordBreak: "break-word", // Breaks the word if it overflows
        whiteSpace: "normal", // Allows text wrapping
      }}
    >
      0322d0e43b3d92d30ed187f4e101a9a9605c3ee5fc9721e6dac3ce3d7732fbb13e@164.92.106.32:9735
    </Code>

    <p>This consists of three parts:</p>

    <ol>
      <li>
        <strong>Public Key</strong>: The first part is the node's public key.
        This is a unique identifier for the node, and is used to identify the
        node on the network. In this case, the public key is{" "}
        <Code
          style={{
            wordWrap: "break-word", // Ensures the word wraps to the next line
            wordBreak: "break-word", // Breaks the word if it overflows
            whiteSpace: "normal", // Allows text wrapping
          }}
        >
          0322d0e43b3d92d30ed187f4e101a9a9605c3ee5fc9721e6dac3ce3d7732fbb13e
        </Code>
        .
      </li>
      <li>
        <strong>IP address</strong>: The second part is the IP address of the
        node. This is how your node will connect to the peer. In this case, the
        IP address is <Code>164.92.106.32</Code>.
      </li>
      <li>
        <strong>Port</strong>: The third part is the port number. This is the
        port on which the node is listening for incoming connections. A common
        port for lightning nodes is <Code>9735</Code>.
      </li>
    </ol>

    <p>
      Rizful Node nodes, as well as many other nodes on the network, use a TOR
      address instead of an IP address. A TOR address looks like this:
    </p>
    <Code
      style={{
        wordWrap: "break-word", // Ensures the word wraps to the next line
        wordBreak: "break-word", // Breaks the word if it overflows
        whiteSpace: "normal", // Allows text wrapping
      }}
    >
      03c2160ebbad3c18156bf613598a54ad3147ae4ea3916a2c8a3983680e7b99e3e1@rex4zwmuwmv7ftnsf37p3giydqvhmpuzzcpjezhpxjjm26j7neeoxjad.onion:9735
    </Code>

    <p> A TOR address is similar, and also consists of three parts:</p>

    <ol>
      <li>
        {" "}
        Public Key: The first part is the node's public key, in this case:{" "}
        <Code
          style={{
            wordWrap: "break-word", // Ensures the word wraps to the next line
            wordBreak: "break-word", // Breaks the word if it overflows
            whiteSpace: "normal", // Allows text wrapping
          }}
        >
          03c2160ebbad3c18156bf613598a54ad3147ae4ea3916a2c8a3983680e7b99e3e1
        </Code>
      </li>
      <li>
        {" "}
        Onion address: The second part is the onion address, in this case
        <Code
          style={{
            wordWrap: "break-word", // Ensures the word wraps to the next line
            wordBreak: "break-word", // Breaks the word if it overflows
            whiteSpace: "normal", // Allows text wrapping
          }}
        >
          rex4zwmuwmv7ftnsf37p3giydqvhmpuzzcpjezhpxjjm26j7neeoxjad.onion
        </Code>
      </li>
      <li>
        {" "}
        Port: The third part is the port number, which again is{" "}
        <Code>9735</Code>
      </li>
    </ol>

    <p>You can see your existing peers with this button: </p>

    <DocsButton
      ariaLabel="add peers"
      text="Peers"
      leftSection={<IconUsers />}
      disabled={false}
    />
  </TypographyStylesProvider>
);
